import React from 'react';

export const HomeDeliveryIcon = (props: React.SVGAttributes<SVGElement>) => (
  <svg role="none" width="32" height="32" viewBox="0 0 32 32" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M26.3115 16.1182V29.7363H5.68965V16.1182C4.17005 17.3808 1.94575 17.3049 0.533447 15.8564L16.0006 -0.00732422L22.4444 6.60319V1.97509H26.3115V10.5695L31.4677 15.8564C30.054 17.3049 27.8297 17.3808 26.3115 16.1182Z"
      fill="currentColor"
    />
  </svg>
);
